import { useCallback, useState } from 'react';

/**
 * input에 관한 상태와 핸들러를 한번에 제공해주는 Hook
 * @param initialValue 해당 input 초기 상태값
 * @returns {[value, valueHandler]} 상태와 해당 상태 핸들러함수
 */
const useInput = (
  initialValue: string,
): [string, (e: any) => void, (str: string) => void] => {
  const [value, setValue] = useState(initialValue);

  const valueHandler = useCallback((e: any) => {
    setValue(e.target.value);
  }, []);
  return [value, valueHandler, setValue];
};

export default useInput;
